// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"ce89b589","355":"54051210","956":"2cc5463e"}[chunkId] + ".chunk.js";
};